module.exports = __webpack_public_path__ + "media/images/brandmaker-73c811298c6a948d2d8057c6b1710a5b.png";